import { type FC } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { CampaignDashboardText } from "./CampaignDashboardTypes";

interface CampaignTablePaginationProps {
  text: CampaignDashboardText;
  currentPage: number;
  totalPages: number;
  formatInteger: (_value: number) => string;
  onPageChange: (_page: number) => void;
}

const CampaignTablePagination: FC<CampaignTablePaginationProps> = ({
  text,
  currentPage,
  totalPages,
  formatInteger,
  onPageChange,
}) => {
  const { t: translate } = useTranslation();

  return (
    <nav className="campaign-dashboard__pagination" aria-label={text.activeCampaigns}>
      <span className="campaign-dashboard__pagination-label">
        {text.pageOf
          .replace("{{current}}", formatInteger(currentPage))
          .replace("{{total}}", formatInteger(totalPages))}
      </span>
      <div className="campaign-dashboard__pagination-controls">
        <button
          type="button"
          className="campaign-dashboard__pagination-btn"
          aria-label={translate("pagination.previousPage")}
          disabled={currentPage <= 1}
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        >
          <ChevronLeft size={16} aria-hidden />
        </button>
        <button
          type="button"
          className="campaign-dashboard__pagination-btn"
          aria-label={translate("pagination.nextPage")}
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        >
          <ChevronRight size={16} aria-hidden />
        </button>
      </div>
    </nav>
  );
};

export default CampaignTablePagination;
